import { en } from './en';
import { vi } from './vi';

export * from './crmTranslateCodes';

export const crmLocale = {
    en,
    vi
};